import React from 'react'
import { Box } from '@material-ui/core'
import { injectIntl } from 'react-intl'
import RouteMapLink from 'wrappers/RouteMapLink/RouteMapLink'
import { useStyles } from './TechlinkJobCard_style'

const TechlinkJobCardWrapper = (props) => {
    const classes = useStyles()
    const { children, job, intl } = props
    const { formatMessage } = intl

    const getJobShowUrl = () => {
        if (job.type === 'first_job') return `techlink/${formatMessage({ id: 'routes.first-jobs' })}/${job.url}`
        if (job.type === 'student_job') return `techlink/${formatMessage({ id: 'routes.student-jobs' })}/${job.url}`
        if (job.type === 'internship') return `techlink/${formatMessage({ id: 'routes.internships' })}/${job.url}`
    }

    return (
        <Box className={classes.jobCardWrapper} key={`jobcard_${job.id}`}>
            <RouteMapLink
                page={getJobShowUrl()}
                className={classes.routeMapLinkStyle}
            >
                {children}
            </RouteMapLink>
        </Box>
    )
}

export default injectIntl(TechlinkJobCardWrapper)
